<section class="update-dialog">
  <div class="title">{{'text_updatePluginsAndThemes' | dbText}}</div>
  <div class="description">{{'text_areYouSureYouWantToUpdate' | dbText}}
    @if (pluginsCount) {
      {{ pluginsCount }}
    }
    @if (pluginsCount && themesCount) {
      {{'text_and' | dbText}}
    }
    @if (themesCount) {
      {{ themesCount }}
    }
  </div>
  <div class="actions-container">
    <div class="ds-btn-gray" (click)="activeDialog.close(false)">{{'text_cancel' | dbText}}</div>
    <div class="ds-btn-black" (click)="activeDialog.close(true)">{{'text_update' | dbText}}</div>
  </div>
</section>
